// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card-info-container-nfxnm {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 36px;
}

.product-card-info-image-duEGP {
  width: 64px;
  height: 64px;
}

.product-card-info-imageTransition-SrbRx {
  width: 64px;
  height: 64px;
  border-radius: 32px;
  background-color: var(--color-neutral-100);
  animation: product-card-info-pulse-JcgNg 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.product-card-info-title-mX8ls {
  margin-top: 16px;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-neutral-800);
}

.product-card-info-titleTransition-Lvuj6 {
  min-width: 120px;
  color: transparent;
  background-color: var(--color-neutral-100);
  border-radius: var(--radius-sm);
  animation: product-card-info-pulse-JcgNg 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes product-card-info-pulse-JcgNg {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/product-card/product-card-info/product-card-info.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,iFAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,iFAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 36px;\n}\n\n.image {\n  width: 64px;\n  height: 64px;\n}\n\n.imageTransition {\n  width: 64px;\n  height: 64px;\n  border-radius: 32px;\n  background-color: var(--color-neutral-100);\n  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.title {\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--color-neutral-800);\n}\n\n.titleTransition {\n  min-width: 120px;\n  color: transparent;\n  background-color: var(--color-neutral-100);\n  border-radius: var(--radius-sm);\n  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `product-card-info-container-nfxnm`,
	"image": `product-card-info-image-duEGP`,
	"imageTransition": `product-card-info-imageTransition-SrbRx`,
	"pulse": `product-card-info-pulse-JcgNg`,
	"title": `product-card-info-title-mX8ls`,
	"titleTransition": `product-card-info-titleTransition-Lvuj6`
};
export default ___CSS_LOADER_EXPORT___;
